import { render, staticRenderFns } from "./PatientList.vue?vue&type=template&id=052a8507&"
import script from "./PatientList.vue?vue&type=script&lang=js&"
export * from "./PatientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports